var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"invalid-feedback list-unstyled",style:(_vm.display)},_vm._l((_vm.errors),function(message,index){return _c('li',[_vm._v(_vm._s(_vm._f("trans")(message)))])}),0)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aa50f70","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/form-errors.vue
// module id = YXcU
// module chunks = 23